import { MagnifyingGlass } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(MagnifyingGlass);
Icon.displayName = "MagnifyingGlass";

export { Icon as MagnifyingGlass };
//# sourceMappingURL=MagnifyingGlass.js.map
